module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page album-detail-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('canvas', {
    staticClass: "background-image",
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-overlay",
    attrs: {
      "id": "back_image"
    }
  }), _vm._v(" "), (_vm.playlist) ? _c('v-flex', {
    staticClass: "album-pages",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('div', {
    staticClass: "album-info-page",
    attrs: {
      "id": "album_info_page"
    }
  }, [_c('div', {
    staticClass: "album-image-section"
  }, [_c('div', {
    staticClass: "album-image playlist",
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-hover-section"
  }, [_c('div', {
    staticClass: "play-button-section"
  }, [(!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    staticClass: "play"
  }, [_vm._v("play_arrow")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pause"
  }, [_vm._v("pause")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "action-section"
  })]), _vm._v(" "), _c('div', {
    staticClass: "album-detail-section"
  }, [_c('div', {
    staticClass: "album-info-section"
  }, [_c('label', {
    staticClass: "album-title"
  }, [_vm._v(_vm._s(_vm.playlist.album_type))]), _vm._v(" "), _c('h4', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.playlist.name))]), _vm._v(" "), _c('div', {
    staticClass: "py-2"
  }, [(_vm.currentUser.id == _vm.playlist.user.id) ? _c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("Edit playlist")]), _vm._v(" "), _c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Edit Playlist")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playlist.name),
      expression: "playlist.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updatePlaylist()
      }
    }
  }, [_vm._v("Update Playlist")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deletePlaylist()
      }
    }
  }, [_vm._v("Delete Playlist")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "album-detail"
  }, [_vm._v("\n            by\n            "), _c('router-link', {
    staticClass: "album-detail",
    attrs: {
      "to": '/' + _vm.playlist.user.slug
    }
  }, [_vm._v(_vm._s(_vm.playlist.user.username))]), _vm._v("\n            • 2017 – " + _vm._s(_vm.playlist.tracks.length) + " Songs, 40:22\n          ")], 1)]), _vm._v(" "), (_vm.currentUser.id != _vm.playlist.user.id) ? _c('div', {
    staticClass: "album-tracks-section"
  }, _vm._l((_vm.playlist.tracks), function(track, index) {
    return _c('album-track-item', {
      key: index,
      attrs: {
        "album": _vm.playlist,
        "trackIndex": index
      }
    })
  })) : _c('div', {
    staticClass: "album-tracks-section"
  }, [_c('draggable', {
    staticClass: "track-items",
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.playlist.tracks),
      callback: function($$v) {
        _vm.$set(_vm.playlist, "tracks", $$v)
      },
      expression: "playlist.tracks"
    }
  }, [_c('transition-group', _vm._l((_vm.playlist.tracks), function(track, index) {
    return _c('album-track-item', {
      key: index,
      attrs: {
        "album": _vm.playlist,
        "trackIndex": index,
        "removeTrack": _vm.removeTrack,
        "showStats": true
      }
    })
  }))], 1)], 1)])]), _vm._v(" "), (false && _vm.currentUser) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "album-comment-page": ""
    }
  }, [_c('h4', {
    staticClass: "comment-title"
  }, [_vm._v("Talk to " + _vm._s(_vm.playlist.user.username))]), _vm._v(" "), _c('label', {
    staticClass: "description"
  }, [_vm._v("Comments are only seen by the artist and people you @mention, unless\n        artist makes your comment public.")]), _vm._v(" "), _c('div', {
    staticClass: "comments-section"
  }, [_c('div', {
    staticClass: "tab-section"
  }, [_c('div', {
    staticClass: "comment-tab"
  }, [_c('label', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsCount) + " Comments")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "add-comment-section"
  }, [_c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.currentUser.avatar.thumb.url
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentString),
      expression: "commentString"
    }],
    ref: "comment",
    staticClass: "comment-input",
    attrs: {
      "type": "text",
      "name": "comment_input",
      "placeholder": "Spark a conversation..."
    },
    domProps: {
      "value": (_vm.commentString)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addComments()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentString = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-items"
  }, [_vm._l((_vm.comments), function(comment, index) {
    return _c('div', {
      key: index,
      staticClass: "comment-item"
    }, [_c('div', {
      staticClass: "comment-parent-item"
    }, [_c('profile-item', {
      attrs: {
        "user": comment.user,
        "className": 'comment-user-avatar'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment-content relative"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + comment.user.slug
      }
    }, [_c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(comment.user.username) + "\n                      "), (comment.user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status online"
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('p', {
      staticClass: "commnet-text",
      domProps: {
        "innerHTML": _vm._s(_vm.convertedHTML(comment.body))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-section"
    }, [_c('v-menu', {
      staticClass: "comment-more-action",
      attrs: {
        "offset-y": ""
      }
    }, [_c('v-btn', {
      staticClass: "more-btn",
      attrs: {
        "slot": "activator",
        "dark": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(
      _vm.currentUser.id == _vm.playlist.user.id &&
      comment.status == 'privated'
    ) ? _c('v-list-tile', {
      key: "public",
      nativeOn: {
        "click": function($event) {
          _vm.makePublicComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), _c('label', [_vm._v("Make Public")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id &&
      comment.status == 'published'
    ) ? _c('v-list-tile', {
      key: "private",
      nativeOn: {
        "click": function($event) {
          _vm.makePrivateComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('i', {
      staticClass: "fa fa-eye-slash"
    }), _vm._v(" "), _c('label', [_vm._v("Make Private")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id &&
      _vm.currentUser.id != comment.user.id
    ) ? _c('v-list-tile', {
      key: "block",
      nativeOn: {
        "click": function($event) {
          _vm.blockUser(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_comment_flag.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Block User")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id ||
      _vm.currentUser.id == comment.user.id
    ) ? _c('v-list-tile', {
      key: "delete",
      nativeOn: {
        "click": function($event) {
          _vm.deleteComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_comment_delete.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Delete Comment")])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('label', {
      staticClass: "comment-time"
    }, [_vm._v("Now")])], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.hasMoreComments) ? _c('v-btn', {
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadMoreComments()
      }
    }
  }, [_vm._v("More Comments")]) : _vm._e()], 1)], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "album-recent-page": ""
    }
  }, [_c('h4', {
    staticClass: "recent-title"
  }, [_vm._v("\n        " + _vm._s(_vm.playlist.user.username) + "'s recent reposts\n      ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "recent-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.playlist.user.recent_items), function(feed, index) {
    return (
      ['Album', 'ShopProduct', 'Stream'].indexOf(feed.assoc_type) > -1
    ) ? _c('div', {
      key: feed.id,
      staticClass: "card-container"
    }, [(feed.assoc_type == 'Album') ? _c('track-card', {
      attrs: {
        "objects": _vm.playlist.user.recent_items,
        "objectIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (feed.assoc_type == 'ShopProduct') ? _c('product-card', {
      attrs: {
        "dataObject": feed
      }
    }) : _vm._e(), _vm._v(" "), (feed.assoc_type == 'Stream') ? _c('video-card', {
      attrs: {
        "dataObject": feed
      }
    }) : _vm._e()], 1) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.playlist,
      "dismiss": _vm.dismissDownloadModal
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b90c6346","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/playlist.vue
// module id = 1842
// module chunks = 180